import { theme } from 'antd'
import { cx } from 'antd-style'
import { Children, cloneElement, isValidElement } from 'react'
import type { ComponentProps, PropsWithChildren } from 'react'

import { resolveIconColors } from './iconColors'
import { useStyles } from './styles'

type Props = {
  color?: string
  size?: number
  shape?: 'round' | 'square'
} & PropsWithChildren &
  ComponentProps<'div'>

const DEFAULT_ICON_SIZE = 20
const ICON_SIZE_RATIO = 0.5

export const IconWithBackground = ({
  color,
  size = DEFAULT_ICON_SIZE,
  shape = 'round',
  children,
  className,
  style,
  ...props
}: Props) => {
  const { styles } = useStyles({ color, shape })
  const { token } = theme.useToken()
  const { iconColor } = resolveIconColors(token, color)
  const iconSize = Math.round(size * ICON_SIZE_RATIO)
  const content = Children.map(children, (child) => {
    if (
      !isValidElement<{ color?: string; size?: number | string }>(child) ||
      typeof child.type === 'string'
    ) {
      return child
    }

    return cloneElement(child, {
      color: child.props.color ?? iconColor,
      size: child.props.size ?? iconSize
    })
  })

  return (
    <div
      style={{ ...style, width: size, height: size }}
      className={cx(styles.icon, className)}
      {...props}
    >
      {content}
    </div>
  )
}
